



























































import { defineComponent } from '@vue/composition-api';
import { useJumpstartCartState, useRemoveJumpstartCartItem } from '@/features/jumpstart';
import { useCustomerIdentity } from '@/features/customers';

// components
import SvgIcon from '@/components/SvgIcon.vue';

export default defineComponent({
  name: 'JumpstartInformation',
  components: { SvgIcon },
  setup() {
    const { items, total, vehicle } = useJumpstartCartState();
    const { customer } = useCustomerIdentity();
    const { removeItem } = useRemoveJumpstartCartItem();

    return { items, total, removeItem, customer, vehicle };
  },
});
